import { Audio } from 'expo-av';
import { useCallback, useEffect, useState } from 'react';
import DownloadManager from '@/utils/DownloadManager';
import { logError } from '@/utils/logHandling';

const playbackStatusUpdate = (setIsPlaying: any) => {
  return (playbackStatus: any) => {
    if (playbackStatus.isPlaying) {
      // Update your UI for the playing state
      setIsPlaying(true);
    } else {
      // Update your UI for the paused state
      setIsPlaying(false);
    }
  };
};

export function useExerciseSound(url?: string) {
  const [successfullyLoaded, setSuccessfullyLoaded] = useState<boolean>(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [soundObject] = useState(new Audio.Sound());

  const playSound = useCallback(async () => {
    if (!url) return;
    try {
      const uri = await DownloadManager.getFileUri(url);
      await soundObject.loadAsync({ uri });
      await soundObject.playAsync();
      setSuccessfullyLoaded(true);
      soundObject.setOnPlaybackStatusUpdate(playbackStatusUpdate(setIsPlaying));
    } catch (error) {
      setSuccessfullyLoaded(false);
      logError('Could not load or play audio', error);
    }
  }, [setIsPlaying, url]);

  const stopSound = useCallback(async () => {
    if (!successfullyLoaded) {
      setIsPlaying(false);
      return;
    }
    try {
      await soundObject.stopAsync();
      setIsPlaying(false);
    } catch (error) {
      setIsPlaying(false);
      logError('Could not stop audio playing', error);
    }
  }, [successfullyLoaded]);

  useEffect(() => {
    if (!isPlaying) soundObject.unloadAsync();
  }, [isPlaying]);

  useEffect(() => {
    return () => {
      soundObject?.unloadAsync();
    };
  }, [url]);

  return { playSound, stopSound, isPlaying };
}
